export default __webpack_public_path__ + "static/town-1cb589eb90344bfb7b9ff221428a920a.png";